/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { Modal, ModalProps, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { ModalTitle } from '~components/_common/ModalTitle/ModalTitle';
import { useStyles } from '~src/hooks/useStyles';
import { styleFn } from './style';

export interface AcceptQuestionModalProps extends Partial<ModalProps> {
  isLoading?: boolean;
  onAccept?: () => Promise<unknown>;
  onCancel?: () => void;
}
export const AcceptQuestionModal: React.FC<AcceptQuestionModalProps> = ({
  isLoading,
  onAccept,
  onCancel,
  ...modalProps
}) => {
  const intl = useIntl();
  const styles = useStyles(styleFn);

  return (
    <Modal
      title={
        <ModalTitle
          text={intl.formatMessage({ id: 'accept-question' })}
          icon={['far', 'check-circle']}
        />
      }
      okText={intl.formatMessage({ id: 'accept' })}
      cancelText={intl.formatMessage({ id: 'cancel' })}
      width={420}
      centered
      okButtonProps={{ loading: isLoading }}
      onOk={async () => {
        await onAccept?.();
        onCancel?.();
      }}
      onCancel={onCancel}
      {...modalProps}>
      <p css={styles.modalText}>
        {intl.formatMessage({ id: 'accept-question-full' })}
      </p>
    </Modal>
  );
};
